import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useLanguage } from '../../../context/language';
import { getStrLang } from '../../Translate';
import { getAceiteTermos, getLPCashInfo } from '../../../api/fastcoinService';
import Loading from '../../../assets/loading.gif';
import InputLabel from '@material-ui/core/InputLabel';
import toast, { Toaster } from 'react-hot-toast';
import { IoChevronBackOutline } from 'react-icons/io5';
import moment from 'moment'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import DownloadPdfIcon from '../../../assets/download-pdf.png'

const LPCASH = (props) => {

    const { translate, lang, orderFromDeposit } = useLanguage();
    const cash_option = {
        mx: [{
            name: "Oxxo",
            code: "1602",
            logo: "https://cdn.localpayment.com/logos/oxxo.jpg"
        },
        {
            name: "7-Eleven",
            code: "1610",
            logo: "https://cdn.localpayment.com/logos/7-eleven.png"
        }],
        pe:[{
            name: "Go Money (Cellpower)",
            code: "6057",
            logo: "https://cdn.localpayment.com/logos/cellpower-peru.png"
        },
        {
            name: "GO PERU - WU",
            code: "6054",
            logo: "/wu.png"
        },
        {
            name: "Edpyme Alternativa",
            code: "6036",
            logo: "https://cdn.localpayment.com/logos/edpyme.png"
        },
        {
            name: "Pago Efectivo",
            code: "6040",
            logo: "https://cdn.localpayment.com/logos/Pago-efectivo.png"
        }],
        co:[{
            name: "Efecty",
            code: "1902",
            logo: "https://cdn.localpayment.com/logos/efecty.png"
        },
        {
            name: "Refacil - Super Pagos",
            code: "1913",
            logo: "https://cdn.localpayment.com/logos/refacil.jpg"
        }],
        ar:[{
            name: "Pago Fácil",
            code: "1002",
            logo: "https://cdn.localpayment.com/logos/pagoFacil.png"
        },
        {
            name: "Rapipago",
            code: "1003",
            logo: "https://cdn.localpayment.com/logos/rapipago.jpg"
        },
        {
            name: "Link",
            code: "1009",
            logo: "/link.png"
        }],
        cl:[{
            name: "Servipag",
            code: "2502",
            logo: "https://cdn.localpayment.com/logos/servipag.png"
        }],
        ec:[{
            name: "Zona pago",
            code: "2319",
            logo: "https://cdn.localpayment.com/logos/zonapago.png"
        },
	    {
            name: "Facilito",
            code: "2307",
            logo: "https://cdn.localpayment.com/logos/facilito.jfif"
        },
	    {
            name: "ER Hipermarket",
            code: "2301",
            logo: "https://cdn.localpayment.com/logos/hipermarket.png"
        }],
        cr:[{
            name: "Tele Dolar",
            code: "1401",
            logo: "https://cdn.localpayment.com/logos/payser.png"
        },
	    {
            name: "Red de pagos Hey",
            code: "1402",
            logo: "https://cdn.localpayment.com/logos/hey.png"
        }],
        uy:[{
            name: "Redpagos",
            code: "2202",
            logo: "https://cdn.localpayment.com/logos/redpagos.png"
        },
	    {
            name: "Abitab",
            code: "2203",
            logo: "https://cdn.localpayment.com/logos/abitab.jpg"
        }],
    }

    const country = sessionStorage.getItem("country").toLocaleLowerCase();
    const [loadingInfo, setLoadingInfo] = useState(false);


    const [infoCash, setInfoCash] = useState(sessionStorage.getItem("lp_cash_info") !== null ? JSON.parse(sessionStorage.getItem("lp_cash_info")) : undefined);

    const [currentOption, setCurrentOption] = useState(sessionStorage.getItem("lp_cash_option") !== null ? JSON.parse(sessionStorage.getItem("lp_cash_option")) : {});

    const [barCode, setBarCode] = useState([])

    useEffect(() => {

        function validarTermos() {
            getAceiteTermos(sessionStorage.getItem("order_no"))
                .then(res => {
                    if (res !== undefined) {
                        props.setShowTermos(false);
                    } else {
                        props.setShowTermos(true);
                    }
                    translate();
                })
                .catch(err => {
                    if (err.error.includes("Could not find")) {
                        console.log(err);
                    } else {
                        console.log(err);
                        alert("Please talk with the administrator");
                    }
                    props.setShowTermos(true);
                })
        }
        if (orderFromDeposit !== "") {
            validarTermos();
        }

        if (infoCash !== undefined) {
        }

    }, []);


    useEffect(() => {
        translate();
    }, [translate, country]);

    const downloadPDF = () => {
        const input = document.getElementById('divToConvert');

        html2canvas(input, { logging: true, letterRendering: 1,  allowTaint: false , useCORS: true } ).then(canvas => { 
            const imgData = canvas.toDataURL('image/png');

            const pdf = new jsPDF('p', 'px', 'a4');
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
        
            const widthRatio = pageWidth / canvas.width;
            const heightRatio = pageHeight / canvas.height;
            const ratio = widthRatio > heightRatio ? heightRatio : widthRatio;
        
            const canvasWidth = canvas.width * ratio;
            const canvasHeight = canvas.height * ratio;
        
            const marginX = (pageWidth - canvasWidth) / 2;
            const marginY = (pageHeight - canvasHeight) / 2;
        
            pdf.addImage(imgData, 'JPEG', marginX, marginY, canvasWidth, canvasHeight);

            try{
                var img = new Image();
                img.src = 'https://dashboard.payeasy.tech/favicon/android-icon-72x72.png';
                pdf.addImage(img, "PNG", 1, 1)
            }catch(e){console.log(e)}
      
            pdf.save('cash.pdf');
        })
    }

    useEffect(() => {
        if (currentOption.code && infoCash === undefined) {
            setLoadingInfo(true);
            getLPCashInfo(sessionStorage.getItem("order_no"), {
                payment_code: currentOption.code,
                payment_name: currentOption.name
            }).then(res => {
                if (res !== undefined) {
                    setInfoCash(res);
                    sessionStorage.setItem("lp_cash_info", JSON.stringify(res));
                    setLoadingInfo(false)
                    const chunks = res.ticket?.barcode.match(/.{1,4}/g);
                    setBarCode(chunks)
                } else {
                    setInfoCash({ error: "Please, talk with the Administrator." });
                }
            }).catch(err => {
                console.log(err.response.data.error)
                if (err.response?.data?.error === "invalid_account") {
                    toast.error(getStrLang(lang.nameLang, "invalid_bank_account"))
                }else if (err.response?.data?.error === "invalid_document_id") {
                    toast.error(`${getStrLang(lang.nameLang, "invalid_doc_id")} ${err.response?.data?.document_needed}`)
                }
                console.log(err.toString());
            }).finally(() => {
                setLoadingInfo(false);
                translate();
            });
        }
    }, [currentOption])


    const notify = () => {
        navigator.clipboard.writeText(infoCash?.ticket?.barcode);
        toast.success(getStrLang(lang.nameLang, "notify_toast"));
    }
    return (
        <>
            <Toaster
                toastOptions={{
                    className: '',
                    style: {
                        border: '1px solid #0d4fb8',
                        color: '#0d4fb8',
                        padding: '12px',
                        top: '300px',
                        //  position: 'relative',
                    },
                }}
            />
            {loadingInfo && <div className="group-pix-content">
                <div className="pix-container">
                    <div className="grup-crypto-opt">
                        <div className="msg-pix">
                            <img src={Loading} alt={"loading"} width="30px" height="30px" />
                        </div>
                    </div>
                </div>
            </div>}
            {!loadingInfo && <div style={{ height: '100%' }}>
                <div className='row'>
                    {infoCash ?
                        <div className='col-md-12'>
                            <div className='optionPayment'>
                                <div className='optionPaymentHeader'>
                                    <div className="column-pix-sides">
                                        <button className="btn-split-pix" onClick={() => { setCurrentOption({}); setInfoCash(undefined) }}><IoChevronBackOutline size={25} /> {getStrLang(lang.nameLang, "btn_voltar")}</button>
                                    </div>
                                    <h5 style={{ float: "right" }}>{currentOption.name}</h5>
                                    <button onClick={downloadPDF} className='btn'><img src={DownloadPdfIcon} height={20} /></button>
                                    <div className="content content-ted" id='divToConvert'>
                                        <div className="col-content">
                                            <div className='row' style={{ width: "100%" }}>
                                                <div className='col-2'>
                                                    <img src={currentOption.logo} height={80} width={"100%"} />
                                                </div>
                                                <div className='col-10'>
                                                    <img src={infoCash?.ticket?.image} height={80} width={"100%"} />
                                                </div>
                                            </div>
                                            <hr />
                                            <div onClick={() => notify()} className='row' style={{ cursor: "pointer" }}>
                                                {barCode.map((b) => <div className='col-1' style={{ width: "45px", border: "1px solid black", borderRadius: "5px", padding: "5px", margin: "2px" }}>{b}</div>)}
                                            </div>
                                            <hr />
                                            <div>
                                                <p>{getStrLang(lang.nameLang, "expire_date")}: {moment(infoCash?.ticket?.expirationDate).format("YYYY-MM-DD HH:mm A")}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        :
                        <div className='optionsPaymentsHomeContainer'>
                            <div className='optionsPaymentsHome'>
                                {cash_option[country].map((opt, index) => {
                                    return <div className='btn-home' onClick={() => { setCurrentOption(opt); sessionStorage.setItem("lp_cash_option", JSON.stringify(opt)); }} key={index}>
                                        <div className='imgLogo'>
                                            <img src={opt.logo} height={50} />
                                        </div>
                                        <div className='imgLogo'>
                                            <InputLabel htmlFor="filled-age-native-simple" className='btn-home-text'>{opt.name}</InputLabel>
                                        </div>
                                    </div>
                                })}
                            </div>
                        </div>
                    }
                </div>

            </div>}

        </>)
}

export default LPCASH;